import { supabase, isSupabaseConfigured } from './supabase'

export interface Subscriber {
  id?: string
  email: string
  created_at?: string
}

export async function addSubscriber(email: string): Promise<{success: boolean, error?: string}> {
  try {
    // Check if Supabase is configured
    if (!isSupabaseConfigured()) {
      console.error('Supabase is not configured properly. Cannot add subscriber.');
      return { 
        success: false, 
        error: 'Our database is currently unavailable. Please check Cloudflare environment variables configuration.'
      }
    }
    
    console.log('Attempting to add subscriber with email:', email);
    
    // Validate email format
    if (!email || !email.includes('@')) {
      return { 
        success: false, 
        error: 'Please enter a valid email address.'
      }
    }
    
    // Insert the subscriber
    const { error } = await supabase
      .from('subscribers')
      .insert([{ email }]);
    
    if (error) {
      console.error('Supabase error:', error);
      
      // Check if this is a duplicate email
      if (error.code === '23505' || (error.message && error.message.includes('duplicate'))) {
        console.log('Duplicate email detected');
        return { 
          success: false, 
          error: 'This email is already subscribed.'
        }
      }
      
      // Handle RLS policy errors
      if (error.code === '42501' || (error.message && error.message.includes('policy'))) {
        console.error('RLS policy error details:', error);
        return { 
          success: false, 
          error: 'We encountered a permissions error. Our team has been notified.'
        }
      }
      
      // Handle connection errors
      if (error.code === 'PGRST301' || error.message?.includes('connection')) {
        return {
          success: false,
          error: 'Unable to connect to our services. Please try again later.'
        };
      }
      
      return {
        success: false,
        error: 'An error occurred while processing your request. Please try again.'
      }
    }
    
    console.log('Successfully added subscriber');
    return { success: true }
  } catch (error: any) {
    console.error('Error adding subscriber:', error);
    return { 
      success: false, 
      error: 'An unexpected error occurred. Please try again later.'
    }
  }
}
